/* ==========================================================================
   GALLERY — cot thumbnail + hero (anh/video) + mui ten + caption variant
   Tach tu Giorgio-Tea.html, <script> goc dong 2791-2912.

   Doi voi ban goc:
     - boc trong 1 IIFE, khong con bien roi ra global scope
     - them null-guard: trang khong co gallery thi return, khong nem loi
     - export 4 ham ra window vi cho khac trong trang goi den chung:
         showVariantHero / clearVariantHero  <- dropdown chon vi (dong 3514-3516)
         resetHeroToGallery                  <- sau khi them vao gio (dong 4295, 4353)
         selectThumbByIndex                  <- tien cho ban goi tay
   ========================================================================== */
(function () {
  const heroImg = document.getElementById('heroImg');
  const heroFrameEl = document.querySelector('.hero-frame');
  if (!heroImg || !heroFrameEl) return;

  // Hero thumbnail row
  const thumbImgs = Array.from(document.querySelectorAll('.thumb-col img'));

  // Lock the thumbnail column's height to exactly match the hero image, so extra
  // thumbnails scroll internally instead of spilling past the hero's bottom edge.
  const thumbCol = document.getElementById('thumbCol');
  const thumbColWrap = document.querySelector('.thumb-col-wrap');
  const thumbScrollFade = document.getElementById('thumbScrollFade');
  const thumbScrollDown = document.getElementById('thumbScrollDown');

  // Duoi 860px, CSS chuyen cot thumbnail thanh hang ngang (.gallery column-reverse).
  // Phai khop VOI @media (max-width:860px) trong CSS — doi mot ben la lech ngay.
  const stacked = window.matchMedia('(max-width: 860px)');

  function updateThumbScrollFade() {
    if (!thumbCol || !thumbScrollFade) return;
    // Hang ngang thi mui ten "cuon xuong" vo nghia, CSS da an no.
    if (stacked.matches) {
      thumbScrollFade.style.opacity = '0';
      thumbScrollFade.style.pointerEvents = 'none';
      return;
    }
    const atBottom = thumbCol.scrollTop + thumbCol.clientHeight >= thumbCol.scrollHeight - 2;
    const scrollable = thumbCol.scrollHeight > thumbCol.clientHeight + 2;
    const show = scrollable && !atBottom;
    thumbScrollFade.style.opacity = show ? '1' : '0';
    thumbScrollFade.style.pointerEvents = show ? 'auto' : 'none';
  }

  function syncThumbColHeight() {
    if (thumbColWrap) {
      if (stacked.matches) {
        // FIX: bo chieu cao inline. Neu khong, gia tri cua desktop (= chieu cao hero)
        // dinh lai va tao mot khoang trong bang ca cai anh duoi hang thumbnail.
        thumbColWrap.style.height = '';
      } else {
        const h = heroFrameEl.offsetHeight;
        if (h > 0) thumbColWrap.style.height = h + 'px';
      }
    }
    updateThumbScrollFade();
  }

  // Xoay ngang dien thoai / keo cua so qua lai breakpoint van phai dung
  if (stacked.addEventListener) stacked.addEventListener('change', syncThumbColHeight);
  else if (stacked.addListener) stacked.addListener(syncThumbColHeight);

  if (thumbScrollDown && thumbCol) {
    thumbScrollDown.addEventListener('click', () => {
      thumbCol.scrollBy({ top: 164, behavior: 'smooth' });
    });
  }
  if (thumbCol) thumbCol.addEventListener('scroll', updateThumbScrollFade);
  window.addEventListener('resize', syncThumbColHeight);
  window.addEventListener('load', syncThumbColHeight);
  syncThumbColHeight();

  const prevBtn = document.getElementById('heroArrowPrev');
  const nextBtn = document.getElementById('heroArrowNext');

  function updateArrowState() {
    if (!prevBtn || !nextBtn) return;
    const current = thumbImgs.findIndex(i => i.classList.contains('active'));
    prevBtn.disabled = current <= 0;
    nextBtn.disabled = current !== -1 && current >= thumbImgs.length - 1;
    prevBtn.style.opacity = prevBtn.disabled ? '0.35' : '1';
    nextBtn.style.opacity = nextBtn.disabled ? '0.35' : '1';
    prevBtn.style.cursor = prevBtn.disabled ? 'default' : 'pointer';
    nextBtn.style.cursor = nextBtn.disabled ? 'default' : 'pointer';
  }

  const heroVideo = document.getElementById('heroVideo');

  // Thumbnail chi la ban 90x90. Anh hero lay tu data-src (900x) tren chinh cai thumb do,
  // neu theme khong xuat data-src thi moi lui ve src.
  function heroSrcOf(img) {
    return img.dataset.src || img.getAttribute('data-src') || img.src;
  }

  // True while the hero is showing a flavor variant rather than a gallery photo.
  let variantHeroActive = false;
  const heroCaption = document.getElementById('heroVariantCaption');

  function showVariantHero(src, label) {
    if (!src) return;
    variantHeroActive = true;
    if (heroVideo) { heroVideo.pause(); heroVideo.style.display = 'none'; }
    thumbImgs.forEach(i => i.classList.remove('active'));
    heroImg.style.opacity = 0;
    setTimeout(() => { heroImg.src = src; heroImg.style.opacity = 1; }, 150);
    if (heroCaption) {
      heroCaption.textContent = label || '';
      heroCaption.style.opacity = label ? '1' : '0';
    }
    updateArrowState();
  }

  function clearVariantHero() {
    variantHeroActive = false;
    if (heroCaption) heroCaption.style.opacity = '0';
  }

  // After an item is added the configurator resets, so the frame goes back to the
  // gallery's first photo rather than keeping the last flavor's variant shot.
  function resetHeroToGallery() {
    if (variantHeroActive) selectThumbByIndex(0);
  }

  function selectThumbByIndex(idx) {
    const img = thumbImgs[idx];
    if (!img) return;
    clearVariantHero();
    thumbImgs.forEach(i => i.classList.remove('active'));
    img.classList.add('active');

    const videoWrap = img.closest('.thumb-video-wrap');
    if (videoWrap && heroVideo) {
      // Video thumbnail: swap the hero over to the <video> element instead of the image.
      heroVideo.src = videoWrap.dataset.videoSrc;
      heroImg.style.opacity = 0;
      heroVideo.style.display = 'block';
      heroVideo.play().catch(() => {});
    } else {
      // heroVideo only exists on the biscotti page. Guarding the `if` condition was not
      // enough — this branch dereferenced it too, so on every page WITHOUT a video
      // thumbnail the click handler threw here and the hero never swapped.
      if (heroVideo) {
        heroVideo.pause();
        heroVideo.style.display = 'none';
      }
      heroImg.style.opacity = 0;
      setTimeout(() => { heroImg.src = heroSrcOf(img); heroImg.style.opacity = 1; }, 150);
    }
    updateArrowState();
  }

  thumbImgs.forEach((img, idx) => {
    img.addEventListener('click', () => selectThumbByIndex(idx));
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const current = thumbImgs.findIndex(i => i.classList.contains('active'));
      if (current > 0) selectThumbByIndex(current - 1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const current = thumbImgs.findIndex(i => i.classList.contains('active'));
      // From a variant photo, forward returns to the first gallery shot.
      if (current === -1) return selectThumbByIndex(0);
      if (current < thumbImgs.length - 1) selectThumbByIndex(current + 1);
    });
  }
  updateArrowState();

  // Cho phan con lai cua trang goi vao (dropdown chon vi, reset sau khi add to cart)
  window.showVariantHero   = showVariantHero;
  window.clearVariantHero  = clearVariantHero;
  window.resetHeroToGallery = resetHeroToGallery;
  window.selectThumbByIndex = selectThumbByIndex;
})();


(function () {
  const WRAP_SEL = '.fd-wrap';
  const OPT_SEL = '.fd-option, .fd-collection-row';

  // Trang thai phai song NGOAI DOM: element bi thay moi lan doi variant, nen
  // luu tren element la mat ngay sau lan chon dau tien.
  const pickedKeys = new Set();     // key -> khach da chon that su chua
  const lastValue = new Map();      // key -> value da chon lan gan nhat
  // KHONG dung id: tren trang that ca 3 dropdown (vi, kieu, ribbon) deu mang
  // id="flavorDropdown" — dung id thi gia tri nho cua cai nay de len cai kia.
  // Thu tu xuat hien trong DON on dinh qua cac lan render lai, dung lam khoa.
  const keyOf = w => 'fd-' + Array.prototype.indexOf.call(document.querySelectorAll(WRAP_SEL), w);

  /* ---------- helper: tat ca deu tra cuu LIVE, khong cache ---------- */
  const menuOf = w => w.querySelector('.fd-menu');
  const nameOf = w => w.querySelector('.fd-trigger-name');
  const subOf = w => w.querySelector('.fd-trigger-sub');
  const optionsOf = w => Array.from(w.querySelectorAll(OPT_SEL));

  function valueOf(el) {
    if (!el) return '';
    const dv = el.getAttribute('data-value');
    if (dv) return dv;
    const t = el.querySelector('.fd-option-name-text, .fd-collection-title');
    return t ? t.textContent.trim() : '';
  }
  function descOf(el) {
    const s = el && el.querySelector('.fd-option-sub');
    return s ? s.textContent.trim() : '';
  }
  function promptOf(w) {
    return w.getAttribute('data-prompt') || 'Choose your tea';
  }

  /* ---------- dong bo sang control that cua theme ---------- */
  function syncNative(wrap, value) {
    let el = null;

    const sel = wrap.getAttribute('data-sync');
    if (sel) el = document.querySelector(sel);

    // Khong khai bao data-sync: do tim trong cung form mot <select> co option
    // trung value, hoac mot radio co value trung.
    if (!el) {
      const scope = wrap.closest('form') || document;
      el = Array.from(scope.querySelectorAll('select')).find(s =>
        Array.from(s.options).some(o => o.value === value || o.textContent.trim() === value)
      );
      if (!el) {
        const radio = Array.from(scope.querySelectorAll('input[type="radio"]'))
          .find(r => r.value === value);
        if (radio) el = radio;
      }
    }
    if (!el) return false;

    if (el.type === 'radio') {
      if (el.checked) return true;
      el.checked = true;
    } else {
      if (el.value === value) return true;
      el.value = value;
    }
    // Theme lang nghe 'change'; vai theme lang nghe 'input'. Ban ca hai.
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* ---------- chon ---------- */
  // picked = false: dong bo giao dien theo DOM, khong coi la thao tac cua khach
  //          va khong ban su kien sang theme.
  // Option nao co o mau (.fd-option-swatch, vd ribbon) thi trigger cung hien o mau
  // do. Copy nguyen attribute style cua swatch — mau nam trong inline style
  // ("background: #DD5117"), khong co class rieng cho tung mau.
  // Option khong co swatch (vi tra, kieu nen) thi trigger khong hien gi.
  function syncSwatch(wrap, el) {
    const trigger = wrap.querySelector('.fd-trigger');
    if (!trigger) return;
    let tSw = trigger.querySelector('.fd-trigger-swatch');
    const oSw = el && el.querySelector('.fd-option-swatch');

    if (!oSw) {
      if (tSw) tSw.remove();
      return;
    }
    if (!tSw) {
      tSw = document.createElement('span');
      tSw.className = 'fd-trigger-swatch';
      // Dat TRUOC phan chu, giong thu tu swatch -> ten trong option
      const text = trigger.querySelector('.fd-trigger-text');
      trigger.insertBefore(tSw, text || trigger.firstChild);
    }
    tSw.setAttribute('style', oSw.getAttribute('style') || '');
    injectSwatchCss();
  }

  function injectSwatchCss() {
    if (document.getElementById('gg-swatch-css')) return;
    const s = document.createElement('style');
    s.id = 'gg-swatch-css';
    s.textContent =
      '.fd-trigger{display:flex;align-items:center;gap:12px;}' +
      '.fd-trigger-swatch{width:22px;height:22px;flex-shrink:0;display:inline-block;}' +
      '.fd-trigger-text{flex:1;min-width:0;}';
    document.head.appendChild(s);
  }

  function apply(wrap, el, picked) {
    const nEl = nameOf(wrap);
    const sEl = subOf(wrap);

    optionsOf(wrap).forEach(o => o.classList.toggle('selected', o === el));

    if (nEl) {
      // Hien thi uu tien data-label (ten than thien, vd "Matte Black Lid"),
      // con data-value giu nguyen ten option value cua Shopify de syncNative
      // con tim dung radio. Khong co data-label thi chay y nhu cu.
      nEl.textContent = el ? (el.getAttribute('data-label') || valueOf(el)) : promptOf(wrap);
      nEl.style.color = el ? '' : 'var(--support-gray)';
    }
    if (sEl) sEl.innerHTML = '';
    wrap.classList.toggle('chosen', !!el);
    syncSwatch(wrap, el);
    if (el && picked) {
      pickedKeys.add(keyOf(wrap));
      lastValue.set(keyOf(wrap), valueOf(el));
    }

    if (el) {
      wrap.classList.remove('needs-choice');
      const err = document.getElementById('flavorErrorMsg');
      if (err) err.style.display = 'none';
    }

    if (el && picked) {
      // Anh rieng cua vi duoc chon chiem khung hero. Co y KHONG day vao cot
      // thumbnail — gallery van la bo anh co dinh cua san pham.
      const hero = el.getAttribute('data-hero');
      if (hero && typeof window.showVariantHero === 'function') {
        window.showVariantHero(hero, valueOf(el));
      } else if (typeof window.clearVariantHero === 'function') {
        window.clearVariantHero();
      }
      syncNative(wrap, valueOf(el));
    }

    if (typeof window.recalc === 'function') window.recalc();
    if (typeof window.updateCtaTotal === 'function') window.updateCtaTotal();
  }

  /* ---------- chuan hoa mot .fd-wrap vua xuat hien trong DOM ---------- */
  function normalize(wrap) {
    if (!wrap || wrap.dataset.fdReady === '1') return;
    wrap.dataset.fdReady = '1';

    // Chu goc tren trigger la loi moi mac dinh — nho lai truoc khi ghi de.
    if (!wrap.hasAttribute('data-prompt')) {
      const n = nameOf(wrap);
      if (n) wrap.setAttribute('data-prompt', n.textContent.trim());
    }
    // Be rong sot lai tu lan render truoc; do lai luc mo.
    const m = menuOf(wrap);
    if (m) m.style.width = '';

    apply(wrap, resolveSelected(wrap), false);
  }

  /* ---------- xac dinh option nao dang duoc chon, theo 3 nguon ----------
     Sau khi doi variant, markup moi thuong KHONG dang tin: Liquid hoac quen
     danh dau selected, hoac danh dau ca 11 dong (thieu dieu kien
     `{% if option.selected_value == value %}`). Nen thu lan luot:
       1. Gia tri module da nho tu lan chon truoc  <- song qua moi lan re-render
       2. Dung MOT .selected trong markup
       3. Gia tri hien tai cua control that (data-sync)
     Het ca ba thi coi nhu chua chon, hien lai loi moi.                     */
  function resolveSelected(wrap) {
    const opts = optionsOf(wrap);

    const remembered = lastValue.get(keyOf(wrap));
    if (remembered) {
      const hit = opts.find(o => valueOf(o) === remembered);
      if (hit) return hit;
    }

    const marked = opts.filter(o => o.classList.contains('selected'));
    if (marked.length === 1) return marked[0];

    // Shopify LUON co san mot variant duoc chon, nen neu tin control that ngay
    // tu dau thi trigger khong bao gio hien duoc loi moi "Choose Your Tea".
    // Mac dinh chi doc no SAU khi khach da chon that su. Muon dropdown luon
    // bam theo variant hien tai (ke ca lan load dau), dat data-follow-native="1".
    if (pickedKeys.has(keyOf(wrap)) || wrap.getAttribute('data-follow-native') === '1') {
      const nv = nativeValue(wrap);
      if (nv) {
        const hit = opts.find(o => valueOf(o) === nv);
        if (hit) return hit;
      }
    }
    return null;
  }

  function nativeValue(wrap) {
    const sel = wrap.getAttribute('data-sync');
    const el = sel ? document.querySelector(sel) : null;
    if (!el) return '';
    if (el.type === 'radio') return el.checked ? el.value : '';
    return el.value || '';
  }

  function normalizeAll(root) {
    (root || document).querySelectorAll(WRAP_SEL).forEach(normalize);
  }

  /* ---------- mo / dong ---------- */
  // Menu bung sang phai vao khoang trong ben phai trang thay vi de len gallery.
  // Do be rong ngay luc mo nen luon dung truoc mep viewport.
  function sizeMenu(wrap) {
    const menu = menuOf(wrap);
    if (!menu) return;
    // The menu used to be widened into whatever space was free to the right,
    // up to 660px, so long collection names would not truncate. It overhung the
    // field it belongs to and covered Add to Bag — and truncated anyway. The
    // stylesheet now pins it to the field and the ROW wraps instead, so the only
    // job left here is clearing any width a previous version left behind.
    menu.style.width = '';
  }

  function closeAll(except) {
    document.querySelectorAll('.cd-wrap.open, .fd-wrap.open').forEach(w => {
      if (w !== except) w.classList.remove('open');
    });
  }

  /* ---------- LISTENER: gan mot lan tren document, khong bao gio chet ---------- */
  document.addEventListener('click', (e) => {
    // 1. Nut "View N flavors" cua bo suu tap: chi de xem, khong bao gio chon.
    const toggle = e.target.closest('.fd-collection-toggle');
    if (toggle) {
      e.stopPropagation();
      const row = toggle.closest('.fd-collection-row');
      const list = row && row.querySelector('.fd-collection-list');
      const chev = toggle.querySelector('.fd-collection-chevron');
      if (list) list.hidden = !list.hidden;
      if (chev) chev.classList.toggle('open', list ? !list.hidden : false);
      return;
    }

    // 2. Bam vao trigger -> mo / dong
    const trigger = e.target.closest('.fd-trigger');
    if (trigger) {
      const wrap = trigger.closest(WRAP_SEL);
      if (wrap) {
        normalize(wrap);
        const willOpen = !wrap.classList.contains('open');
        closeAll();
        if (willOpen) { wrap.classList.add('open'); sizeMenu(wrap); }
      }
      return;
    }

    // 3. Bam vao mot dong trong menu -> chon
    const opt = e.target.closest(OPT_SEL);
    if (opt) {
      const wrap = opt.closest(WRAP_SEL);
      if (wrap) {
        normalize(wrap);          // phong khi observer chua kip chay
        apply(wrap, opt, true);
        wrap.classList.remove('open');
      }
      return;
    }

    // 4. Bam ra ngoai -> dong het
    closeAll();
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.fd-wrap.open').forEach(sizeMenu);
  });

  /* ---------- BAT DOM BI THAY (doi variant / section render lai) ---------- */
  // Chi lam viec khi xuat hien .fd-wrap chua co co data-fd-ready, nen gan nhu
  // khong ton gi du observer gan tren body.
  // KHONG dung requestAnimationFrame o day. rAF dat lich tu trong callback cua
  // MutationObserver co the KHONG BAO GIO chay (tab bi throttle, hoac trinh
  // duyet khong dat lich ve frame moi vi mutation dien ra giua chuoi xu ly
  // click dong bo). Khi do latch ket lai va observer chet sau dung mot lan —
  // trieu chung y het: doi variant lan dau con dung, tu lan hai la text reset.
  let queued = false;
  const scheduleNormalize = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;                       // nha latch TRUOC, du ben duoi co loi
      try {
        if (document.querySelector('.fd-wrap:not([data-fd-ready="1"])')) normalizeAll();
      } catch (err) {
        if (window.console) console.error('[flavor-dropdown]', err);
      }
    }, 0);
  };
  new MutationObserver(scheduleNormalize)
    .observe(document.documentElement, { childList: true, subtree: true });

  // Shopify ban su kien nay khi section duoc render lai trong theme editor.
  document.addEventListener('shopify:section:load', (e) => normalizeAll(e.target));

  /* ---------- khoi tao ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeAll());
  } else {
    normalizeAll();
  }

  /* ---------- API ---------- */
  const mainWrap = () => document.querySelector('#flavorDropdown') || document.querySelector(WRAP_SEL);

  window.selectFlavor = function (value, picked) {
    const wrap = mainWrap();
    if (!wrap) return;
    const el = optionsOf(wrap).find(o => valueOf(o) === value);
    if (el) apply(wrap, el, picked !== false);
  };
  window.getSelectedFlavor = function () {
    const wrap = mainWrap();
    const el = wrap && wrap.querySelector('.fd-option.selected, .fd-collection-row.selected');
    return el ? { value: valueOf(el), sub: descOf(el), el: el } : null;
  };
  window.isFlavorPicked = function () {
    const wrap = mainWrap();
    return !!(wrap && pickedKeys.has(keyOf(wrap)));
  };
})();


(function () {
  const SELECTOR = '.sealsubs-target-element';           // widget Seal
  const TARGET = '.sls-selling-plan-group-options';      // o chon tan suat cua Seal
  const TIMEOUT_MS = 30000;                              // bo cuoc sau 30s, khong quan sat mai
  const t0 = performance.now();

  // 1. Khoi mo ta, chen NGAY TRUOC o chon tan suat
  const BODY_FALLBACK = 'Your morning ritual, replenished on your schedule. <br>Skip, reschedule, or cancel anytime.';

  // 2. Nhan tren hang nut tan suat
  const FREQ_FALLBACK = 'How Often Should We Roast For You?';

  /* ---- copy the merchant can edit ------------------------------------------
     These two lines used to be hard-coded here, which is why the biscotti page
     sat for weeks showing the candle page's wording (this file began as a copy
     of it) and the client could not correct it from the theme editor -- there
     was nothing to edit. main-product-giorgio.liquid now publishes whatever is
     typed into the section's "Subscription wording" fields as window.ggSubCopy;
     the lines above stay as the fallback, so a shop that leaves those fields
     empty renders exactly as before. */
  const GG_SUB = window.ggSubCopy || {};
  const BODY_HTML = '<div id="pkgSubBody">' + (GG_SUB.body || BODY_FALLBACK) + '</div>';
  const FREQ_LABEL = GG_SUB.freq || FREQ_FALLBACK;

  // 3. Link duoi hang nut. Doi HELP_HREF thanh URL that neu co trang huong dan.
  const HELP_TEXT = 'How Many Bags Do I Need?';
  const HELP_HREF = '#';
  const HELP_CLASS = 'bags-help-link';   // dung class, khong dung id: co the dat
                                         // nhieu link mo popup o nhieu cho khac nhau

  // Doi ten nut. Key = text goc cua <option> ben Seal (khong phan biet hoa thuong).
  // Khong khop key nao thi giu nguyen text cua Seal.
  const RENAME = {
    'every 1 month': 'Monthly',
    'every 2 months': 'Every 2 Months',
    'every 3 months': 'Every 3 Months',
    'every 12 months': 'Annual Gift'
  };

  const CSS = [
    "#pkgSubBody{font-family:'Montserrat',sans-serif;font-size:13.5px;line-height:1.6;color:var(--ink-soft,#5A524F);margin:12px 0 0;}",
    '#pkgSubFreq{margin:16px 0 0;border-top:1px solid var(--gray,#D9D9D6);padding-top:16px;}',
    "#pkgFreqLabel{font-family:'Montserrat',sans-serif;font-size:11.5px;letter-spacing:.09em;text-transform:uppercase;color:var(--ink,#2B2523);margin-bottom:10px;}",
    '#pkgFreqOptions{display:flex;gap:6px;flex-wrap:wrap;}',
    '.' + HELP_CLASS + "{display:inline-block;margin-top:12px;font-family:'Montserrat',sans-serif;font-size:11.5px;letter-spacing:.09em;text-transform:uppercase;color:var(--support-gray,#808080);text-decoration:underline;}",
    ".pkg-freq-btn{font-family:'Montserrat',sans-serif;font-size:13.5px;color:var(--ink,#2B2523);background:var(--white,#fff);border:1.5px solid var(--gray,#D9D9D6);border-radius:0;padding:11px 10px;cursor:pointer;white-space:nowrap;transition:border-color .15s,color .15s;}",
    '.pkg-freq-btn:hover{border-color:#B3B3B3;}',
    '.pkg-freq-btn.selected{border-color:var(--raspberry,#CE0F69);color:var(--raspberry,#CE0F69);}'
  ].join('\n');

  let observer = null;
  let timer = null;

  function stop() {
    if (observer) { observer.disconnect(); observer = null; }
    if (timer) { clearTimeout(timer); timer = null; }
  }

  // Widget co the xuat hien TRUOC khi ruot no render xong, nen dieu kien "san
  // sang" phai la cho can chen, khong phai chi rieng .sealsubs-target-element.
  function findSpot() {
    const root = document.querySelector(SELECTOR);
    return root ? root.querySelector(TARGET) : null;
  }

  function injectCss() {
    if (document.getElementById('gg-freq-css')) return;
    const s = document.createElement('style');
    s.id = 'gg-freq-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // Bien <select> cua Seal thanh hang nut pill. Giu nguyen cai <select>, chi an
  // di — bam nut la ghi value roi ban 'change' de logic cua Seal chay binh thuong.
  function buildPills(spot) {
    const select = spot.querySelector('select');
    if (!select) {
      console.warn('[seal] khong thay <select> trong ' + TARGET + ' — chua doi thanh nut duoc.');
      console.warn('  innerHTML:', spot.innerHTML);
      return;
    }
    if (spot.querySelector('#pkgSubFreq')) return;

    select.style.display = 'none';

    const box = document.createElement('div');
    box.id = 'pkgSubFreq';

    const label = document.createElement('div');
    label.id = 'pkgFreqLabel';
    label.textContent = FREQ_LABEL;

    const row = document.createElement('div');
    row.id = 'pkgFreqOptions';

    Array.from(select.options).forEach(function (opt) {
      const raw = opt.textContent.trim();
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pkg-freq-btn' + (opt.selected ? ' selected' : '');
      btn.setAttribute('data-value', opt.value);
      btn.textContent = RENAME[raw.toLowerCase()] || raw;

      btn.addEventListener('click', function () {
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        row.querySelectorAll('.pkg-freq-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
      });

      row.appendChild(btn);
    });

    box.appendChild(label);
    box.appendChild(row);

    if (!spot.querySelector('.' + HELP_CLASS)) {
      const help = document.createElement('a');
      help.className = HELP_CLASS;
      help.href = HELP_HREF;
      help.textContent = HELP_TEXT;
      box.appendChild(help);
    }

    spot.appendChild(box);
  }

  function found(spot, how) {
    stop();
    const ms = Math.round(performance.now() - t0);

    injectCss();
    if (!document.getElementById('pkgSubBody')) {
      spot.insertAdjacentHTML('beforebegin', BODY_HTML);
    }
    buildPills(spot);

    window.$seal = document.querySelector(SELECTOR);
    console.log('[seal] xong sau ' + ms + 'ms (' + how + ')');
    console.log('  -> da gan vao window.$seal');
  }

  /* --------------------------------------------------------------------
     Bam "How Many Tins Do I Need?" -> mo modal.
     CSS co san: .pair-modal{display:none} / .pair-modal.open{display:flex}
     Uu tien #planModal, khong co thi lay .pair-modal dau tien.
     Khong tim thay modal nao thi KHONG chan link — de no chay binh thuong.
     Dat listener tren document nen khong phu thuoc thu tu render.
     -------------------------------------------------------------------- */
  const MODAL_ID = 'planModal';

  function getModal() {
    return document.getElementById(MODAL_ID) || document.querySelector('.pair-modal');
  }

  document.addEventListener('click', function (e) {
    
    if (e.target.closest('.' + HELP_CLASS)) {
      console.log(1)
      const modal = getModal();
      console.log(2)
      if (!modal) return;
      console.log(3)
      e.preventDefault();
      
      modal.classList.add('open');
      return;
    }
    // Dong: bam nut close, hoac bam ra nen ngoai panel
    const openModal = document.querySelector('.pair-modal.open');
    if (!openModal) return;
    if (e.target.closest('.pair-modal-close') || !e.target.closest('.pair-modal-panel')) {
      openModal.classList.remove('open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const m = document.querySelector('.pair-modal.open');
    if (m) m.classList.remove('open');
  });

  // Co san roi thi khoi quan sat
  const now = findSpot();
  if (now) { found(now, 'da co san luc script chay'); return; }

  observer = new MutationObserver(function () {
    const spot = findSpot();
    if (spot) found(spot, 'MutationObserver');
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  timer = setTimeout(function () {
    stop();
    console.warn('[seal] KHONG thay ' + TARGET + ' sau ' + TIMEOUT_MS + 'ms — da dung quan sat.');
  }, TIMEOUT_MS);
})();


/* ==========================================================================
   GIA THEO SO LUONG — dong bo 3 cho cung luc:
     1. Gia trong tung dong Seal        $16.00  ->  $48.00   (qty 3)
     2. Gia goc gach ngang .sls-price-below
     3. Nut Add to cart                 "Add to cart | $43.20"

   CAI BAY QUAN TRONG:
   Sau lan nhan dau tien, DOM khong con giu don gia nua. Doc lai gia dang hien
   de nhan tiep la NHAN HAI LAN ($16 -> $48 -> $144). Nen don gia duoc chup MOT
   LAN va cat vao data-gg-unit tren chinh dong do; moi phep tinh sau deu xuat
   phat tu do, khong bao gio tu gia dang hien thi.

   Seal render lai khi doi variant -> dong la element MOI, khong co data-gg-unit
   -> tu dong chup lai gia moi. Khong can don dep gi.
   ========================================================================== */
(function () {
  const ROW_SEL = '.sealsubs-container .sls-option-container';
  // Cac o gia GOC (gach ngang) do app Seal render. Chung phai bi loai khoi
  // priceNode() — neu khong, "text node cuoi cung co tien" co the roi trung o
  // gia goc va don gia chup duoc se sai.
  const BELOW_SEL = '.sls-price-below, .sls-original-price';
  const BTN_SEL = 'button[name="add"], .product-form__submit';
  const QTY_SEL = 'input[name="quantity"]';
  const PRICE_CLASS = 'gg-btn-price';
  const SEP = ' | ';
  const MONEY = /\$\s?[\d,]+(?:\.\d+)?/;

  // Gia cua theme, dung khi trang khong co widget Seal
  const FALLBACK_PRICE_SEL = '.price-item--sale, .price-item--regular, .price__regular .price-item, .product__price';

  function qtyNow() {
    const el = document.querySelector(QTY_SEL);
    const n = el ? parseInt(el.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function toNumber(s) {
    const m = String(s).match(/[\d.,]+/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }

  // Giu nguyen dinh dang cua nguon: ky hieu tien te, dau phay, so chu so thap phan.
  // $16.00 x3 -> $48.00 ;  $14.40 x3 -> $43.20 ;  $1,600.00 x2 -> $3,200.00
  function formatLike(sample, value) {
    const m = sample.match(/[\d.,]+/);
    if (!m) return String(value);
    const numStr = m[0];
    const prefix = sample.slice(0, m.index);
    const suffix = sample.slice(m.index + numStr.length);

    const dot = numStr.lastIndexOf('.');
    let dec = dot === -1 ? 0 : numStr.length - dot - 1;
    if (dec === 0 && value % 1 !== 0) dec = 2;   // mau khong co xu nhung ket qua co

    const parts = value.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return prefix + parts.join('.') + suffix;
  }

  // The theme prints whole dollars without the .00 (gio_no_cents). Seal's own
  // rows keep Seal's format — that is its DOM — but everything this script
  // writes for itself is printed the theme's way from the start. Printing
  // $16.00 here and letting the page-wide script correct it afterwards set
  // two writers against each other: the correction read as drift, was
  // re-imposed, was corrected again, and the button price and the sticky bar
  // flickered for as long as the page was open.
  function noCents(text) {
    if (!window.gioNoCents) return text;
    return String(text).replace(/([$€£¥]\s?[\d,]+)\.00(?!\d)/g, '$1');
  }

  // Text node dang giu gia cua khoi. Bo qua .sls-price-below — do la gia goc
  // gach ngang, khong phai gia dang tinh tien.
  function priceNode(root) {
    if (!root) return null;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let hit = null;
    let n;
    while ((n = walker.nextNode())) {
      if (n.parentElement && n.parentElement.closest(BELOW_SEL)) continue;
      if (MONEY.test(n.nodeValue)) hit = n;
    }
    return hit;
  }

  // Don gia, chup mot lan roi cat lai. Day la thu duy nhat moi phep nhan dua vao.
  function unitOf(box) {
    if (!box.dataset.ggUnit) {
      const node = priceNode(box);
      if (!node) return '';
      const m = node.nodeValue.match(MONEY);
      if (!m) return '';
      box.dataset.ggUnit = m[0].trim();
    }
    return box.dataset.ggUnit;
  }

  function rows() {
    return Array.from(document.querySelectorAll(ROW_SEL));
  }

  function activeRow(list) {
    return list.filter(function (b) {
      const r = b.querySelector('input[type="radio"]');
      return r && r.checked;
    })[0] || list.filter(function (b) { return b.classList.contains('sls-active'); })[0] || null;
  }

  // Don gia rieng cua .sls-price-below. Chup mot lan, giong unitOf() — doc lai
  // gia da nhan de nhan tiep la nhan hai lan. Con trong (Seal chua render xong)
  // thi khong chup, de lan sau thu lai.
  function belowUnitOf(el) {
    if (!el.dataset.ggUnit) {
      const m = el.textContent.match(MONEY);
      if (!m) return '';
      el.dataset.ggUnit = m[0].trim();
    }
    return el.dataset.ggUnit;
  }

  // Sua SO TIEN tai cho, khong dung textContent = ...
  // Seal boc gia trong <span class="money conversion-bear-money seal-money ...">;
  // ghi de textContent la xoa luon span do, mat ca cac app doi tien te dang bam
  // vao no. Chi thay text node ben trong.
  function setMoneyIn(el, unitText, q) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node = null;
    let n;
    while ((n = walker.nextNode())) {
      if (MONEY.test(n.nodeValue)) node = n;
    }
    if (!node) return;
    const want = formatLike(unitText, toNumber(unitText) * q);
    if (node.nodeValue.indexOf(want) === -1) {
      node.nodeValue = node.nodeValue.replace(MONEY, want);
    }
  }

  function applyRows(list, q) {
    list.forEach(function (box) {
      const unit = unitOf(box);
      if (!unit) return;

      // 1. Gia chinh cua dong
      const node = priceNode(box);
      if (node) {
        const want = formatLike(unit, toNumber(unit) * q);
        if (node.nodeValue.indexOf(want) === -1) {
          node.nodeValue = node.nodeValue.replace(MONEY, want);
        }
      }

      // 2. Gia goc gach ngang: app Seal tu do noi dung vao, minh KHONG ghi gia
      //    nua — chi nhan theo so luong cho khop voi gia chinh. Khong nhan thi
      //    qty 3 se ra "$16.00 gach / $43.20" — lech.
      //    querySelectorAll: mot dong co the co ca .sls-price-below lan
      //    .sls-original-price tuy phien ban app.
      box.querySelectorAll(BELOW_SEL).forEach(function (el) {
        const bUnit = belowUnitOf(el);
        if (bUnit) setMoneyIn(el, bUnit, q);
      });
    });
  }

  function applyButton(list, q) {
    const btn = document.querySelector(BTN_SEL);
    if (!btn) return;

    // Don gia cua dong dang chon; khong co widget Seal thi lay gia cua theme
    let unit = '';
    const active = activeRow(list);
    if (active) unit = unitOf(active);
    if (!unit) {
      const el = document.querySelector(FALLBACK_PRICE_SEL);
      const node = priceNode(el);
      if (node) unit = (node.nodeValue.match(MONEY) || [''])[0].trim();
    }
    if (!unit) return;

    const text = SEP + noCents(formatLike(unit, toNumber(unit) * q));

    let el = btn.querySelector('.' + PRICE_CLASS);
    if (!el) {
      el = document.createElement('span');
      el.className = PRICE_CLASS;
      // Vao TRONG span nhan ("Add to cart"), khong phai vao thang nut —
      // de khong dinh vao .loading__spinner
      const label = btn.querySelector('span:not(.' + PRICE_CLASS + ')') || btn;
      label.appendChild(el);
    }
    // Khong doi thi khong ghi — neu ghi lai, MutationObserver duoi se tu kich
    // lai chinh no vo han
    if (el.textContent === text) return;
    el.textContent = text;
  }

  // Doi variant: Dawn render lai section, nhung Seal thuong chi DOI TEXT gia tai
  // cho — element .sls-option-container song sot, mang theo data-gg-unit cu.
  // Khong xoa cache thi script nhan don-gia-cu x qty va ghi de len gia moi cua
  // Seal ($28 de len $50). Bat bang input[name="id"]: doi id -> xoa het cache,
  // NGUNG ghi mot nhip (Seal viet gia moi xong da), roi moi chup lai.
  let lastVariantId = null;
  let freezeUntil = 0;
  const FREEZE_MS = 1200;

  function currentVariantId() {
    const el = document.querySelector('input[name="id"]');
    return el ? el.value : null;
  }

  function clearUnitCache() {
    document.querySelectorAll('[data-gg-unit]').forEach(function (el) {
      el.removeAttribute('data-gg-unit');
    });
  }

  function apply() {
    const vid = currentVariantId();
    if (lastVariantId === null) {
      lastVariantId = vid;
    } else if (vid !== lastVariantId) {
      lastVariantId = vid;
      clearUnitCache();
      freezeUntil = Date.now() + FREEZE_MS;
      setTimeout(apply, FREEZE_MS + 50);   // chup lai sau khi Seal on dinh
      return;
    }
    if (Date.now() < freezeUntil) return;

    const list = rows();
    const q = qtyNow();
    applyRows(list, q);
    applyButton(list, q);
  }

  // Doi so luong (go tay hoac bam +/-), doi variant, doi goi subscription
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches(QTY_SEL)) apply();
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches) return;
    if (e.target.matches(QTY_SEL) || e.target.type === 'radio' || e.target.tagName === 'SELECT') apply();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.sls-option-container, .pkg-freq-btn, quantity-input, .quantity')) {
      setTimeout(apply, 0);
    }
  });

  // Theme render lai section khi doi variant -> nut va cac dong la element moi.
  // setTimeout chu khong requestAnimationFrame: rAF dat lich tu trong callback
  // cua MutationObserver co the khong bao gio chay, latch se ket vinh vien.
  let queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      try { apply(); } catch (err) { if (window.console) console.error('[qty-price]', err); }
    }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);

  window.ggRefreshPrices = apply;
})();


/* ==========================================================================
   YOUR SELECTION — bang tom tat lua chon, dat tren nut Add to cart

     YOUR SELECTION
     Finest Teas                          $80  $72     [ - 5 + ]
     Peppermint Herbal (20 ct)                          Remove
     Always On Hand + Save 10% · Monthly

   Toan bo noi dung suy ra tu DOM dang song, khong giu state rieng:
     ten SP        <- h1 cua trang
     dong mo ta    <- vi dang chon (window.getSelectedFlavor, hoac <select> variant)
     dong ghi chu  <- nhan dong Seal dang chon + "Save X%" + tan suat dang chon
     gia was/now   <- don gia da chup (data-gg-unit) x so luong
     so luong      <- input[name=quantity], dong bo hai chieu

   Cho dat: theme co san <div id="pendingOrder"></div> thi dung cho do;
   khong co thi tu chen ngay TRUOC nut Add to cart.
   ========================================================================== */
(function () {
  const HOST_ID = 'pendingOrder';
  const TITLE = 'Your Selection';
  const ROW_SEL = '.sealsubs-container .sls-option-container';
  const ORIG_SEL = '.sls-price-below, .sls-original-price';
  const BTN_SEL = 'button[name="add"], .product-form__submit';
  const QTY_SEL = 'input[name="quantity"]';
  const MONEY = /\$\s?[\d,]+(?:\.\d+)?/;

  const CSS = [
    '.pending-order{border-top:1.5px solid var(--gray,#D9D9D6);padding:28px 0 14px;margin:26px 0 20px;}',
    ".pending-order-title{font-family:'Montserrat',sans-serif;font-size:15px;font-weight:500;letter-spacing:.09em;text-transform:uppercase;color:var(--support-gray,#808080);margin-bottom:6px;}",
    '.pending-order .pairing-row{display:grid;grid-template-columns:1fr auto;gap:20px;align-items:center;border-top:none;padding:16px 0;}',
    '.pending-order .pairing-row + .pairing-row{border-top:1px solid var(--gray,#D9D9D6);}',
    ".pairing-row-name{font-family:'Montserrat',sans-serif;font-size:13.5px;font-weight:500;letter-spacing:.03em;color:var(--ink,#2B2523);}",
    '.order-row .pairing-row-name{display:flex;justify-content:space-between;align-items:baseline;gap:14px;}',
    '.order-row .order-amt{font-weight:500;white-space:nowrap;letter-spacing:0;font-family:\'Montserrat\',sans-serif;font-size:14px;}',
    '.order-was{color:var(--support-gray,#808080);text-decoration:line-through;font-weight:400;margin-right:8px;}',
    '.order-now{color:var(--ink,#2B2523);font-weight:400;}',
    // Raspberry means money saved. An undiscounted price is ink like any
    // other number on the page.
    '.order-now.is-cut{color:var(--raspberry,#CE0F69);}',
    ".pairing-row-desc{font-family:'Montserrat',sans-serif;font-size:14px;color:var(--ink-soft,#5A524F);margin-top:3px;}",
    ".order-sub-note{font-family:'Montserrat',sans-serif;font-size:11.5px;font-weight:500;letter-spacing:.03em;color:var(--raspberry,#CE0F69);margin-top:6px;}",
    '.pairing-row-actions{display:flex;flex-direction:column;align-items:flex-end;gap:8px;}',
    '.oi-qty-stepper{display:flex;align-items:center;border:1.5px solid var(--gray,#D9D9D6);width:108px;height:44px;justify-content:space-between;box-sizing:border-box;}',
    '.oi-qty-stepper button{width:34px;height:auto;padding:0;border:none;background:var(--white,#fff);font-size:18px;cursor:pointer;color:var(--ink,#2B2523);}',
    '.oi-qty-stepper button:hover{background:var(--gray,#D9D9D6);}',
    '.oi-qty-stepper .oi-qty-val{width:40px;text-align:center;font-size:15px;font-weight:400;}',
    ".pairing-remove{background:none;border:none;padding:0;cursor:pointer;font-family:'Montserrat',sans-serif;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:var(--support-gray,#808080);text-decoration:none;}",
    '.pairing-remove:hover{color:var(--raspberry,#CE0F69);}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('gg-selection-css')) return;
    const s = document.createElement('style');
    s.id = 'gg-selection-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function qtyInput() { return document.querySelector(QTY_SEL); }

  function qtyNow() {
    const el = qtyInput();
    const n = el ? parseInt(el.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function toNumber(s) {
    const m = String(s).match(/[\d.,]+/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }

  // Giu nguyen dinh dang cua nguon (ky hieu tien te, dau phay, so chu so thap phan)
  function formatLike(sample, value) {
    const m = String(sample).match(/[\d.,]+/);
    if (!m) return String(value);
    const numStr = m[0];
    const prefix = String(sample).slice(0, m.index);
    const suffix = String(sample).slice(m.index + numStr.length);
    const dot = numStr.lastIndexOf('.');
    let dec = dot === -1 ? 0 : numStr.length - dot - 1;
    if (dec === 0 && value % 1 !== 0) dec = 2;
    const parts = value.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return prefix + parts.join('.') + suffix;
  }

  // The theme prints whole dollars without the .00 (gio_no_cents). Seal's own
  // rows keep Seal's format — that is its DOM — but everything this script
  // writes for itself is printed the theme's way from the start. Printing
  // $16.00 here and letting the page-wide script correct it afterwards set
  // two writers against each other: the correction read as drift, was
  // re-imposed, was corrected again, and the button price and the sticky bar
  // flickered for as long as the page was open.
  function noCents(text) {
    if (!window.gioNoCents) return text;
    return String(text).replace(/([$€£¥]\s?[\d,]+)\.00(?!\d)/g, '$1');
  }

  function rows() { return Array.from(document.querySelectorAll(ROW_SEL)); }

  function selectedRow(list) {
    return list.filter(function (b) {
      const r = b.querySelector('input[type="radio"]');
      return r && r.checked;
    })[0] || list.filter(function (b) { return b.classList.contains('sls-active'); })[0] || null;
  }

  function onceRow(list) {
    return list.filter(function (b) {
      return !b.querySelector('.sls-selling-plan-group-options');
    })[0] || null;
  }

  // Don gia da chup boi IIFE gia-theo-so-luong (data-gg-unit).
  // Chua co thi doc tam tu DOM, nho bo o gia goc ra khoi phep doc.
  function unitOf(box) {
    if (!box) return '';
    if (box.dataset && box.dataset.ggUnit) return box.dataset.ggUnit;
    const clone = box.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll(ORIG_SEL), function (n) { n.remove(); });
    const m = clone.textContent.match(MONEY);
    return m ? m[0].trim() : '';
  }

  function productTitle() {
    const el = document.querySelector('.product__title h1, h1.product__title, .product-title, .product__info-wrapper h1, h1');
    return el ? el.textContent.trim() : '';
  }

  // Vi dang chon: uu tien dropdown tu lam, khong co thi lay tu <select> variant
  function variantText() {
    /* Everything the shopper has chosen, one line each — flavour, occasion,
       ribbon, lid — the way the bag lists a line. Neutral values ("No
       Ribbon") say nothing and are left out, as the bag leaves them out. */
    const parts = [];
    const seen = {};
    function addPart(v) {
      v = String(v == null ? '' : v).trim();
      if (!v) return;
      const k = v.toLowerCase();
      if (k === 'default title' || k === 'no ribbon' || seen[k]) return;
      seen[k] = 1;
      parts.push(v);
    }

    document.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fs) {
      const r = fs.querySelector('input[type="radio"]:checked');
      if (r) addPart(r.value);
    });
    document.querySelectorAll('variant-selects select, variant-radios select').forEach(function (s) {
      addPart(s.value);
    });
    // Property pickers (the lid, and friends) mirror into a hidden select.
    document.querySelectorAll('select.gg-prop-select').forEach(function (s) {
      const o = s.options[s.selectedIndex];
      addPart(o ? o.text || o.value : s.value);
    });

    if (parts.length) return parts.join('\n');

    if (typeof window.getSelectedFlavor === 'function') {
      const f = window.getSelectedFlavor();
      if (f && f.value) return f.value;
    }
    const trig = document.querySelector('.fd-wrap.chosen .fd-trigger-name');
    if (trig && trig.textContent.trim()) return trig.textContent.trim();

    const sel = document.querySelector('select[name^="options"]');
    if (sel && sel.value) return sel.value;
    return '';
  }

  // "Always On Hand + Save 10% · Monthly" — rong khi dang chon one-time
  function planNote(sel) {
    if (!sel || !sel.querySelector('.sls-selling-plan-group-options')) return '';

    const label = sel.querySelector('label');
    let name = '';
    if (label) {
      const clone = label.cloneNode(true);
      Array.prototype.forEach.call(
        clone.querySelectorAll('input, .gg-save-note, ' + ORIG_SEL),
        function (n) { n.remove(); }
      );
      name = clone.textContent.replace(MONEY, '').replace(/\s+/g, ' ').trim();
    }

    const parts = [];
    if (name) parts.push(name);

    const save = sel.querySelector('.gg-save-note');
    if (save) parts.push(save.textContent.trim());

    const head = parts.join(' + ');

    let freqText = '';
    const freq = sel.querySelector('.pkg-freq-btn.selected');
    if (freq) {
      freqText = freq.textContent.trim();
    } else {
      const s = sel.querySelector('select');
      if (s && s.selectedIndex > -1) freqText = s.options[s.selectedIndex].textContent.trim();
    }

    if (!freqText) return head;
    return head ? head + ' · ' + freqText : freqText;
  }

  function host() {
    let el = document.getElementById(HOST_ID);
    if (el) return el;
    const btn = document.querySelector(BTN_SEL);
    if (!btn) return null;
    el = document.createElement('div');
    // Same value is still a mutation record to every observer on the page,
    // and the panel re-renders on mutations — so an unconditional write here
    // kept the whole page's observers ticking for as long as it was open.
    if (el.className !== 'pending-order') el.className = 'pending-order';
    el.id = HOST_ID;
    const anchor = btn.closest('.product-form') || btn;
    anchor.parentNode.insertBefore(el, anchor);
    return el;
  }
  // Ban HTML da ghi lan truoc. Phai nho o day thay vi doc lai el.innerHTML:
  // chuoi dung o duoi chua thuc the (&ndash;) con innerHTML tra ve ky tu that (–),
  // hai ben khong bao gio bang nhau -> guard vo hieu -> ghi lai ~185 lan/giay va
  // cac nut +/-/Remove bi huy ngay duoi con tro nen khach khong bam duoc.

  // Cap nhat TAI CHO thay vi gan lai ca innerHTML.
  //
  // Gan innerHTML se pha huy roi dung lai moi node con: khoi Your Selection
  // "giat" mot cai moi lan bam +/-, va nut dang nam duoi con tro bi thay mat
  // nen cu bam nhanh la truot. Morph chi sua dung text/thuoc tinh nao khac.
  //
  // Node co [data-gg-keep] la cua module khac chen vao (vd thanh "in your bag"),
  // khong thuoc ban render nay -> bo qua khi so sanh va giu lai khi phai thay ca khoi.
  function ggKids(n) {
    return Array.prototype.filter.call(n.childNodes, function (c) {
      return !(c.nodeType === 1 && c.hasAttribute && c.hasAttribute('data-gg-keep'));
    });
  }

  function ggMorph(cur, next) {
    var a = ggKids(cur), b = ggKids(next), i, j, at;
    if (a.length !== b.length) return false;
    for (i = 0; i < b.length; i++) {
      var x = a[i], y = b[i];
      if (x.nodeType !== y.nodeType || x.nodeName !== y.nodeName) return false;
      if (x.nodeType === 3 || x.nodeType === 8) {
        if (x.nodeValue !== y.nodeValue) x.nodeValue = y.nodeValue;
        continue;
      }
      if (x.nodeType !== 1) continue;
      for (j = y.attributes.length - 1; j >= 0; j--) {
        at = y.attributes[j];
        if (x.getAttribute(at.name) !== at.value) x.setAttribute(at.name, at.value);
      }
      for (j = x.attributes.length - 1; j >= 0; j--) {
        at = x.attributes[j];
        if (at.name !== 'data-gg-keep' && !y.hasAttribute(at.name)) x.removeAttribute(at.name);
      }
      if (!ggMorph(x, y)) return false;
    }
    return true;
  }

  function ggWrite(el, html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    if (el.firstChild && ggMorph(el, tmp)) return;      // sua tai cho, khong giat
    var keep = Array.prototype.slice.call(el.querySelectorAll('[data-gg-keep]'));
    el.innerHTML = html;
    // Tra ve DAU khoi chu khong don xuong cuoi: module so huu node se tu dat lai
    // dung cho cua no, nhung dat o dau la mac dinh hop ly hon.
    keep.forEach(function (k) { el.insertBefore(k, el.firstChild); });
  }

  var lastHost = null;
  var lastHtml = '';


  function render() {
    const list = rows();
    const sel = selectedRow(list);
    const once = onceRow(list);

    const unitSel = unitOf(sel);
    if (!unitSel) return;                       // chua co gia -> chua ve
    const unitOnce = unitOf(once);

    const q = qtyNow();
    const now = noCents(formatLike(unitSel, toNumber(unitSel) * q));
    const was = unitOnce && toNumber(unitOnce) > toNumber(unitSel)
      ? noCents(formatLike(unitOnce, toNumber(unitOnce) * q))
      : '';

    const title = productTitle();
    const variant = variantText();
    const note = planNote(sel);

    const html =
      '<div class="pending-order-title">' + esc(TITLE) + '</div>' +
      '<div class="pairing-row order-row is-on">' +
        '<div>' +
          '<div class="pairing-row-name"><span>' + esc(title) + '</span></div>' +
          (variant
            ? variant.split('\n').map(function (line) {
                return '<div class="pairing-row-desc">' + esc(line) + '</div>';
              }).join('')
            : '') +
          (note ? '<div class="order-sub-note">' + esc(note) + '</div>' : '') +
        '</div>' +
        '<div class="pairing-row-actions">' +
          // Price sits above the counter, not beside the name: the amount and the
          // controls that change it belong to each other.
          '<span class="order-amt">' +
            (was ? '<span class="order-was">' + esc(was) + '</span>' : '') +
            '<span class="order-now' + (was ? ' is-cut' : '') + '">' + esc(now) + '</span>' +
          '</span>' +
          '<div class="oi-qty-stepper">' +
            '<button type="button" data-gg-step="-1">&ndash;</button>' +
            '<span class="oi-qty-val">' + q + '</span>' +
            '<button type="button" data-gg-step="1">+</button>' +
          '</div>' +
          '<button type="button" class="pairing-remove" data-gg-reset="1">Remove</button>' +
        '</div>' +
      '</div>';

    const el = host();
    if (!el) return;
    if (lastHost === el && lastHtml === html) return;
    lastHost = el;
    lastHtml = html;
    ggWrite(el, html);
  }

  // Stepper trong bang nay dieu khien chinh o quantity cua theme, khong giu so
  // rieng — hai cho lech nhau la khach thay mot dang, gio hang nhan mot neo.
  function setQty(v) {
    const el = qtyInput();
    if (!el) return;
    el.value = String(Math.max(1, v));
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    const step = e.target.closest('[data-gg-step]');
    if (step && step.closest('#' + HOST_ID)) {
      e.preventDefault();
      setQty(qtyNow() + parseInt(step.getAttribute('data-gg-step'), 10));
      return;
    }

    const reset = e.target.closest('[data-gg-reset]');
    if (reset && reset.closest('#' + HOST_ID)) {
      e.preventDefault();
      setQty(1);
      // ve one-time neu dang chon subscription
      const once = onceRow(rows());
      const radio = once && once.querySelector('input[type="radio"]');
      if (radio && !radio.checked) radio.click();
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches(QTY_SEL)) render();
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches) return;
    if (e.target.matches(QTY_SEL) || e.target.type === 'radio' || e.target.tagName === 'SELECT') render();
  });

  // setTimeout chu khong requestAnimationFrame: rAF dat lich tu trong callback
  // cua MutationObserver co the khong bao gio chay, latch se ket vinh vien.
  let queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      try { render(); } catch (err) { if (window.console) console.error('[selection]', err); }
    }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  injectCss();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  window.addEventListener('load', render);

  window.ggRefreshSelection = render;
})();


(function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.subscription-block')) return;
    e.preventDefault();   // href="#" se nhay len dau trang truoc khi kip cuon

    var timer = setInterval(function () {
      var el = document.querySelector('.sls-purchase-options-container .sls-option-container:nth-child(3)');
      if (!el) return;
      clearInterval(timer);
      (el.querySelector('input[type="radio"]') || el).click();   // chọn luôn gói subscription
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  });
})();


/* ==========================================================================
   PACKAGING CARDS (.pkg-cards / .pkg-card)  ->  doi variant Shopify

   Theme (Dawn) doi variant bang RADIO trong <variant-selects>:
     <input type="radio" name="Vessel-2" value="Tapered Candle">
   Doi radio + ban 'change'  ->  Dawn fetch section moi va render lai.

   Card chi la lop ao: bam card -> tick radio co cung value -> Dawn lo phan
   con lai. Sau khi render lai, Liquid tu in class "selected" cho card dung
   (xem packaging-cards.liquid), nen KHONG can giu state gi trong JS.

   YEU CAU: data-value cua card = DUNG option value ("Tapered Candle"),
   khong phai khoa tu dat ("dozen"). Khong khop thi khong tim duoc radio.

   Listener tren document (capture) -> song qua re-render, va theme nao
   stopPropagation tren card cung khong chan duoc.
   ========================================================================== */
(function () {
  const CARD = '.pkg-card';
  const WRAP = '.pkg-cards';

  function valueOf(card) {
    const dv = card.getAttribute('data-value');
    if (dv) return dv;
    const t = card.querySelector('.pkg-card-title');
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  // Radio cua theme co value trung. Bo qua radio cua Seal (.sealsubs-container).
  // Uu tien radio nam trong <variant-selects>; khong co thi bat ky radio nao
  // ngoai Seal. Neu .pkg-cards khai bao data-option-name="Vessel" thi chi lay
  // radio co name bat dau bang ten do (phong truong hop 2 option trung value).
  function radioFor(wrap, value) {
    const optName = (wrap.getAttribute('data-option-name') || '').trim().toLowerCase();
    const all = Array.from(document.querySelectorAll('input[type="radio"]')).filter(function (r) {
      if (r.closest('.sealsubs-container')) return false;
      if (r.value !== value) return false;
      if (optName && r.name.trim().toLowerCase().indexOf(optName) !== 0) return false;
      return true;
    });
    return all.filter(function (r) { return r.closest('variant-selects, variant-radios'); })[0] || all[0] || null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    const card = e.target.closest(CARD);
    if (!card) return;
    const wrap = card.closest(WRAP);
    if (!wrap) return;

    const value = valueOf(card);
    if (!value) return;

    // Phan hoi ngay, khong doi Dawn fetch xong (200-500ms) — khong co la khach
    // tuong bam hut va bam lai
    wrap.querySelectorAll(CARD).forEach(function (c) { c.classList.toggle('selected', c === card); });

    const radio = radioFor(wrap, value);
    if (!radio) {
      if (window.console) console.warn('[pkg-cards] khong thay radio nao co value "' + value + '" — data-value cua card phai DUNG ten option');
      return;
    }
    if (radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  // Ban phim: card la div, them tabindex/role de Tab + Enter/Space dung duoc.
  function makeFocusable() {
    document.querySelectorAll(CARD).forEach(function (c) {
      if (c.hasAttribute('tabindex')) return;
      c.setAttribute('tabindex', '0');
      c.setAttribute('role', 'radio');
    });
    document.querySelectorAll(WRAP).forEach(function (w) {
      if (!w.hasAttribute('role')) w.setAttribute('role', 'radiogroup');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const card = e.target && e.target.closest && e.target.closest(CARD);
    if (!card) return;
    e.preventDefault();
    card.click();
  });

  // Dawn render lai section -> card moi chua co tabindex. setTimeout, khong
  // requestAnimationFrame (rAF trong MutationObserver co the khong bao gio chay).
  let queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; try { makeFocusable(); } catch (err) {} }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', makeFocusable);
  else makeFocusable();
})();
